import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Practice = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.7 6.75-5.3 5.296c-.2.2-.5.3-.8.3l-3.6-.4-1 .9c3 3.297 4.9 7.793 4.9 12.69 0 10.39-8.5 18.884-18.9 18.884-10.5 0-19-8.493-19-18.885C0 15.144 8.5 6.551 18.9 6.551c3 0 5.9.7 8.4 1.998.5.2.7.8.4 1.3-.2.499-.8.699-1.3.399-2.3-1.1-4.8-1.799-7.5-1.799-9.4 0-17 7.594-17 16.986 0 9.393 7.6 16.987 17 16.987s17-7.594 17-16.986c0-4.297-1.6-8.294-4.3-11.291L28 17.842c1.8 2.098 2.8 4.796 2.8 7.693.1 6.495-5.3 11.89-11.8 11.89-6.5 0-12-5.395-12-11.99 0-6.594 5.3-11.89 11.9-11.89 1.3 0 2.6.2 3.8.6.5.2.8.7.6 1.199-.2.5-.7.8-1.2.6-1-.3-2-.5-3.1-.5-5.5 0-9.9 4.496-9.9 9.992 0 5.495 4.5 9.891 9.9 9.891 5.5 0 10-4.496 10-9.891 0-2.398-.8-4.597-2.3-6.295L23 22.838c.5.799.8 1.698.8 2.697 0 2.698-2.2 4.896-4.9 4.896S14 28.233 14 25.535c0-1.998 1.2-3.797 3-4.496.5-.2 1.1 0 1.3.5.2.5 0 1.099-.5 1.299-1 .4-1.8 1.498-1.8 2.697a2.9 2.9 0 0 0 5.8 0c0-.5-.1-.899-.3-1.199l-2 1.999c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2.8-2.797 5-4.996 5-4.996 1.6-1.598-.4-3.597c0-.3.1-.6.3-.8L37.7.856c.3-.4.7-.5 1-.4.4.1.6.5.7.8l.4 3.297 3.3.4c.4.1.7.299.8.699.2.4.1.8-.2 1.099Z"
  }));
});
Practice.displayName = 'Practice';
Practice.defaultProps = {
  'aria-label': 'Practice'
};
export default Practice;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Practice.js
// module id = 3879
// module chunks = 11